module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-voxi-04.838c523c.jpg";